module.exports = __webpack_public_path__ + "static/media/donate-now.ea71b4d8.jpg";